import { memo, useState } from 'react';

import { LayoutGridIcon, PlusIcon } from '@air/design-icons';
import { DropdownMenuItem, DropdownMenuSeparator, DropdownMenuSub } from '@air/primitive-dropdown-menu';

import { WorkspaceHeaderInformationDropdownSwitchWorkspaceItemsWorkspaces } from '~/components/v2/components/workspace/workspace-header/WorkspaceHeaderInformationDropdownSwitchWorkspaceItemsWorkspaces';
import { intercomIDs } from '~/constants/intercomIDs';
import { useCreateWorkspace } from '~/hooks/useCreateWorkspace';

export const WorkspaceHeaderInformationDropdownSwitchWorkspaceItems = memo(() => {
  const [scrollElement, setScrollElement] = useState<HTMLDivElement | null>(null);
  const { createWorkspace } = useCreateWorkspace();

  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuSub
        data-id="SWITCH_WORKSPACE"
        label="Switch workspace"
        prefix={<LayoutGridIcon aria-hidden className="ads:text-icon-subtle text-gray-9" size="sm" />}
        ref={setScrollElement}
        size="small"
        className="ui2026:w-[280px] w-[calc(var(--sidebar-width)-24px)] min-w-[240px] ui2026:min-w-[280px]"
        data-intercomid={intercomIDs.SWITCH_WORKSPACE}
      >
        {scrollElement && (
          <WorkspaceHeaderInformationDropdownSwitchWorkspaceItemsWorkspaces scrollElement={scrollElement} />
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          data-id="create-workspace"
          label="Join or create a workspace"
          onSelect={createWorkspace}
          prefix={<PlusIcon aria-hidden className="ads:text-icon-subtle text-gray-9" size="sm" />}
        />
      </DropdownMenuSub>
    </>
  );
});

WorkspaceHeaderInformationDropdownSwitchWorkspaceItems.displayName =
  'WorkspaceHeaderInformationDropdownSwitchWorkspaceItems';
